import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-[#040F1E] text-white">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800;900&family=DM+Sans:wght@400;500;600;700;800&display=swap');
        .font-syne { font-family: 'Syne', sans-serif; }
        .font-dm { font-family: 'DM Sans', sans-serif; }
      `}</style>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
        <Link to="/" className="font-syne text-3xl font-extrabold text-[#00C4B4] mb-8 inline-block" style={{ letterSpacing: '-1.5px' }}>TAGO</Link>

        <h1 data-testid="terms-heading" className="font-syne text-4xl font-extrabold text-white mb-2">Terms of Service</h1>
        <p className="text-white/40 text-sm font-dm mb-10">Last updated: February 2026</p>

        <div className="space-y-8 font-dm text-white/80 leading-relaxed">
          <section>
            <h2 className="font-syne text-xl font-bold text-white mb-3">1. Acceptance of Terms</h2>
            <p>By accessing or using TAGO ("Service"), operated at tago.bot, you agree to be bound by these Terms of Service. If you do not agree to these terms, do not use the Service.</p>
          </section>

          <section>
            <h2 className="font-syne text-xl font-bold text-white mb-3">2. Beta Disclaimer</h2>
            <div className="bg-[#FF6B35]/10 border border-[#FF6B35]/20 rounded-xl p-4">
              <p className="text-[#FF6B35] font-semibold mb-2">IMPORTANT: This application is in Beta.</p>
              <p className="text-sm">The Service is provided on an "as is" and "as available" basis during the beta period. Features may be incomplete, contain bugs, or change without notice. TAGO makes no guarantees regarding uptime, accuracy, or reliability during the beta phase. Use the Service at your own discretion.</p>
            </div>
          </section>

          <section>
            <h2 className="font-syne text-xl font-bold text-white mb-3">3. Description of Service</h2>
            <p>TAGO provides a QR code-based vehicle contact system. Users can generate QR codes linked to their phone number, print and place them on their vehicles, and allow third parties to scan the code and contact them for legitimate reasons (e.g., blocked vehicle, emergency, accident).</p>
          </section>

          <section>
            <h2 className="font-syne text-xl font-bold text-white mb-3">4. User Accounts</h2>
            <ul className="list-disc list-inside space-y-2 ml-2">
              <li>You must provide accurate and complete information when creating an account</li>
              <li>You are responsible for maintaining the security of your account credentials</li>
              <li>You are responsible for all activities that occur under your account</li>
              <li>You must be at least 18 years old to use this Service</li>
            </ul>
          </section>

          <section>
            <h2 className="font-syne text-xl font-bold text-white mb-3">5. Acceptable Use</h2>
            <p className="mb-3">You agree NOT to use the Service to:</p>
            <ul className="list-disc list-inside space-y-2 ml-2">
              <li>Provide false or misleading contact information</li>
              <li>Harass, abuse, or harm other users or QR code scanners</li>
              <li>Attempt to gain unauthorized access to other accounts or systems</li>
              <li>Use the service for any illegal or unauthorized purpose</li>
              <li>Interfere with or disrupt the Service or its infrastructure</li>
            </ul>
          </section>

          <section>
            <h2 className="font-syne text-xl font-bold text-white mb-3">6. Phone Number Visibility</h2>
            <p>By creating a vehicle QR code, you acknowledge and consent that your associated phone number will be made visible to anyone who scans the QR code and selects a contact reason. It is your responsibility to provide a phone number you are comfortable sharing publicly via the QR code.</p>
          </section>

          <section>
            <h2 className="font-syne text-xl font-bold text-white mb-3">7. Limitation of Liability</h2>
            <p>To the fullest extent permitted by law, TAGO shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of the Service. TAGO is not responsible for any interactions, disputes, or incidents that occur as a result of contact initiated through the QR code system.</p>
          </section>

          <section>
            <h2 className="font-syne text-xl font-bold text-white mb-3">8. Intellectual Property</h2>
            <p>The TAGO name, logo, and all related branding, designs, and technology are the property of TAGO. You may not copy, modify, distribute, or use any TAGO intellectual property without prior written consent.</p>
          </section>

          <section>
            <h2 className="font-syne text-xl font-bold text-white mb-3">9. Termination</h2>
            <p>We reserve the right to suspend or terminate your account at any time, with or without cause, and with or without notice. Upon termination, your right to use the Service will immediately cease.</p>
          </section>

          <section>
            <h2 className="font-syne text-xl font-bold text-white mb-3">10. Changes to Terms</h2>
            <p>We reserve the right to modify these Terms at any time. We will notify users of significant changes. Your continued use of the Service after changes constitutes acceptance of the updated Terms.</p>
          </section>

          <section>
            <h2 className="font-syne text-xl font-bold text-white mb-3">11. Governing Law</h2>
            <p>These Terms shall be governed by and construed in accordance with the laws of the Kingdom of Bahrain, without regard to its conflict of law provisions.</p>
          </section>

          <section>
            <h2 className="font-syne text-xl font-bold text-white mb-3">12. Contact</h2>
            <p>For questions about these Terms, contact us at <a href="mailto:tago.bots@gmail.com" className="text-[#00C4B4] hover:underline">tago.bots@gmail.com</a>.</p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-[rgba(0,196,180,.14)] flex items-center justify-between">
          <span className="text-xs text-white/30">© 2026 TAGO · Kingdom of Bahrain</span>
          <Link to="/privacy" className="text-sm text-[#00C4B4] hover:underline font-dm">Privacy Policy</Link>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
